// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext, useMemo, Fragment, useState,
  useEffect} from 'react';
import cn from 'classnames';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../lib/button';
import {Lottie} from '../lib/lottie';
import {use_browser} from '../lib/use_browser';
import {Settings_context} from '../settings_ctx';
import {img_url} from '../ui/img_url';
import {open_store} from '../ui/install_btn';
import {App_context} from 'hola_app_context';
import {use_element_size, use_screen} from '../lib/screen_util';
import {Svg_img} from '../ui/svg_img';
import {guess_browser} from 'zuser_agent';
import {Tab_buttons} from '../ui/premium/tab_buttons';
import {Modal} from '../lib/modal';
import {Link} from '../ui/link';
// @ts-ignore
import {hola_apps} from '../install_util.js';
import {guess_os_and_version} from '../client_hints_global';
import Icon_appletv_active from '../img/svg/pl/ic-appletv-active.svg';
import Icon_firetv_active from '../img/svg/pl/ic-firetv-active.svg';
import Icon_lg_active from '../img/svg/pl/ic-lg-active.svg';
import Icon_smarttv from '../img/svg/pl/ic-smarttv.svg';
import Icon_xbox_active from '../img/svg/pl/ic-xbox-active.svg';
import Icon_playstation_active from '../img/svg/pl/ic-playstation-active.svg';
import Icon_router from '../img/svg/pl/ic-router.svg';
import Icon_globe from '../img/svg/icon/globe.svg';
import {use_download} from '../ui/use_download';

import styles from './product_hero.module.less';

interface i_product_hero {
    title?: string;
    description?: string;
    lottie_src?: string;
    type: string;
    with_options: boolean;
    only_cta: boolean;
}

interface i_product_hero_props_editor {
    value: i_product_hero;
    on_change: (new_value: i_product_hero)=>void;
}

const captions = {
  extension: {
    getTitle(type, title){
      return `Add to ${title} - is free`;
    }
  },
  mobile: 'Scan the QR code',
  desktop: {
    getTitle(type, title, os){
      return os=='macos' ? 'Get Hola on your Mac'
      : 'Get Hola on your PC';
    }
  },
  tv: 'Choose your TV',
  console: 'Choose your device',
};

export const Product_hero = (props: i_product_hero)=>{
    const {title: hero_title, description, lottie_src, type,
      with_options, only_cta} = props;
    const {theme} = useContext(Settings_context);
    const b = guess_browser();
    const default_qr = b.ios ? 'ios' : b.huawei ? 'huawei' : 'samsung';
    const [modal, set_modal] = useState(false);
    const [active_qr, set_active_qr] = useState(default_qr);
      const [link, set_link] = useState('');
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const {screen} = use_screen();
    const br = use_browser(['chrome', 'opera', 'edge']);
    const {download} = use_download();
    const mobile_apps = hola_apps.mobile;
    const tab_button_items = useMemo(()=>{
        return [
            {id: 'ios', title: 'iOS'},
            {id: 'android', title: 'Android'},
            {id: 'samsung', title: 'Samsung'},
            {id: 'huawei', title: 'Huawei'},
        ];
    }, []);
    const qr_width = active_qr=='android'?170:180;
    const get_link = ()=>{
      set_link(mobile_apps.find(app=>app.name===active_qr)?.href||'');
    };
    useEffect(()=>{
      get_link();
    }, [active_qr]);
    const sys = guess_os_and_version();
    const os = sys.os;
    const title = br.toUpperCase()[0] + br.substring(1);
    const other_browsers = useMemo(()=>{
        if (br == 'chrome')
            return ['opera', 'edge'];
        if (br == 'opera')
            return ['chrome', 'edge'];
        if (br == 'edge')
            return ['chrome', 'opera'];
    }, [br]);
    const tvs = useMemo(()=>{
      return [
        {title: 'Apple TV', icon: <Icon_appletv_active/>,
          link: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?'
          +'platform=appleTV'},
        {title: 'Amazon Fire TV', icon: <Icon_firetv_active/>,
          link: 'https://www.amazon.com/Hola-Free-VPN-Proxy-Unblocker/dp/'
          +'B08XBVQ81K/ref=cm_cr_arp_d_product_top?ie=UTF8'},
        {title: 'LG TV', icon: <Icon_lg_active/>,
          link: 'https://us.lgappstv.com/main/tvapp/detail?appId=1094740&'
          +'catCode1=003&moreYn=N&cateYn=Y&orderType=0&headerName='
          +'Entertainment&appRankCode=&sellrUsrNo=&curPage=22'},
        {title: 'Other smart TVs', icon: <Icon_smarttv/>,
          link: 'https://hola.org/plus_setup?platform=smarttv'}
      ];
    }, []);
    const devices = useMemo(()=>{
      return [
        {title: 'Xbox', icon: <Icon_xbox_active/>,
          link: '/plus_setup?platform=console&type=xbox_one'},
        {title: 'PlayStation', icon: <Icon_playstation_active/>,
          link: '/plus_setup?platform=console&type=ps4'},
        {title: 'Router', icon: <Icon_router/>,
          link: '/plus_setup?platform=router'},
        {title: 'Smart DNS', icon: <Icon_globe/>,
          link: '/plus_setup?platform=smarttv'}
      ];
    }, []);
    const [w, h] = use_element_size(is_client && {
        xs: [240, 200],
        sm: [240, 200],
        md: [240, 200],
        all: [467, 387],
    });
    return <div className={theme.root}><div className={cn(only_cta ?
      styles.center : styles.top)}>
      {type=='mobile' &&
      <Modal is_open={modal} on_close={()=>set_modal(false)} width={400}
        no_logo>
        <div className={styles.qr_modal}>
          <p><b>Scan QR code to get Hola<br/>on your device</b></p>
          <Tab_buttons items={tab_button_items} active={active_qr}
            on_change={set_active_qr} sliding class_name={styles.qr_tabs}/>
          <div>
            <img src={img_url(`qr/${active_qr}.svg`)} width={qr_width}
              height={180} alt={`${active_qr}`} className="lazyload"/>
          </div>
          <p className={cn(theme.p3, theme.med, theme.color_n600, styles.or)}>
            or</p><br/>
            <Link to={link} className={styles.store_link}>Go to Store</Link>
        </div>
      </Modal>}
      {type=='tv' &&
        <Modal is_open={modal} on_close={()=>set_modal(false)} width={400}
          no_logo>
          <div className={styles.qr_modal}>
            <p><b>On which TV do you want Hola?</b></p>
            <p className={theme.p2}>Let's get you set up</p>
            <div className={styles.tv_buttons}>
              {tvs.map((t, i)=>{
                return <button key={i}
                  className={styles.tv_button} onClick={()=>{
                    location.href = t.link;
                  }}>
                  {t.icon} <span className={cn(theme.P, theme.p2, theme.med)}>
                    {t.title}
                  </span>
                </button>;
            })}
            </div>
          </div>
        </Modal>}
      {type=='console' &&
        <Modal is_open={modal} on_close={()=>set_modal(false)} width={400}
          no_logo>
        <div className={styles.qr_modal}>
          <p><b>On which device would you like to have Hola?</b></p>
          <p className={theme.p2}>Let's get you set up</p>
          <div className={styles.tv_buttons}>
            {devices.map((o, i)=>{
              return <button key={i}
                className={styles.tv_button} onClick={()=>{
                  location.href = o.link;
                }}>
                {o.icon} <span className={cn(theme.P, theme.p2, theme.med)}>
                  {o.title}
                </span>
              </button>;
          })}
          </div>
        </div>
      </Modal>}
      <div className={cn(!only_cta && styles.text, only_cta && styles.center)}>
      <h1 className={styles.page_header}>{hero_title}</h1>
      {!only_cta && <p className={theme.u3}>{description}</p>}
      <Button color={'black2023'} caption={captions[type]?.getTitle &&
        captions[type]?.getTitle(type, title, os) ||
        captions[type]}
        on_click={()=>{
          if (type==='extension')
            return open_store(false, br);
          if (type=='desktop')
            return void download();
          set_modal(true);
        }} size={'lg'}/></div>
      {!only_cta && <div className={styles.man_img} key={screen}>
        <Lottie src={img_url(lottie_src)}
          width={w} height={h} autoplay
          cls={styles.man_lottie}/>
        </div>}
      </div>
      {with_options && <div className={styles.other_browsers_wrap}>
        <div className={styles.other_browsers}>
        <p className={cn(theme.p2, theme.med)}>Also available on</p>
        {other_browsers.map(ob=>{
          return <button key={ob}
            className={styles.browser_button} onClick={()=>{
              open_store(true, ob); }}>
            {ob=='opera' && <Fragment>
              <Svg_img id={'svg/pl/ic-opera-active.svg'} w={24} h={24}/><span
                className={cn(theme.P, theme.p2, theme.med)}>
                Opera Browser</span></Fragment>}
            {ob=='edge' && <Fragment>
              <Svg_img id={'svg/pl/ic-edge-active.svg'} w={24} h={24}/><span
                className={cn(theme.P, theme.p2, theme.med)}>Microsoft
                edge</span></Fragment>}
            {ob=='chrome' && <Fragment>
              <Svg_img id={'svg/pl/ic-opera-active.svg'} w={24} h={24}/><span
                className={cn(theme.P, theme.p2, theme.med)}>Chrome
                Browser</span></Fragment>}</button>; })}</div></div>}</div>;
};

export const Product_hero_editor = (props: i_product_hero_props_editor)=>{
  const {value = {title: '', description: '', type: '', lottie_src: '',
    with_options: '', only_cta: false}, on_change} = props;
  type editor_key = keyof i_product_hero;
  type editor_type = 'text' | 'textarea' | 'number' | 'boolean' | 'selector';
  const editors = [
      ['title', 'Title', 'text'],
      ['description', 'Description', 'text'],
      ['lottie_src', 'Animation path', 'text'],
      ['type', 'Type(extension/mobile/desktop/tv/others)', 'text'],
      ['with_options', 'Enable store options', 'boolean'],
      ['only_cta', 'Only CTA', 'boolean'],
  ].map(([key, label, type])=>({key: key as editor_key, label,
      type: type as editor_type}));
  return <Editor
    value={value}
    editors={editors}
    on_change={on_change}
    title="Product_hero"
  />;
};
